// Intl Message Component
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'

class IntlMessage extends Component {
  static get defaultProps () {
    return {
      ident: '',
      html: false,
      value: {},
      multilingual: true
    }
  }

  static get propTypes () {
    return {
      ident: PropTypes.string,
      html: PropTypes.bool,
      value: PropTypes.any,
      multilingual: PropTypes.bool
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    const { ident, html, value, multilingual } = this.props

    if (
      ident !== nextProps.ident ||
      html !== nextProps.html ||
      value !== nextProps.value ||
      multilingual !== nextProps.multilingual
    ) {
      return true
    }
    return false
  }

  render () {
    if (!this.props.multilingual) {
      return <span>{this.props.ident}</span>
    }

    return this.props.html ? (
      <FormattedHTMLMessage
        html
        id={this.props.ident}
        values={this.props.value}
      />
    ) : (
      <FormattedMessage id={this.props.ident} values={this.props.value} />
    )
  }
}

export default IntlMessage
